// @docs https://[domain]/api/v1/docs
export default {
  Detail: "/pyr/companies",
  SettingDetail: "/pyr/companies/{orgId}/settings",
};
